<template>
  <el-dialog :title="title" :visible.sync="addWorkerDialog.show" v-if="addWorkerDialog.show" :close-on-click-modal="false"
    width="1000px">
    <div class="role_rect">
      <el-form class="form_content">
        <el-form-item label="人员角色：" required>
          <el-select @change="changeType" class="select_btn_style filter-item" v-model="filters.classUserType" placeholder="请选择" size="small">
            <el-option v-for="(item, i) in userAddTypeList" :key="i" :label="item.paramValue" :value="Number(item.paramKey)">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="main-contant" v-if="!!filters.classUserType">
      <div class="left-tree" v-show="filters.classUserType !== 5">
        <LeftLazyTree @select="select" @clearCheckedNodes="clearCheckedNodes" showTooltip/>
      </div>
      <div :class="filters.classUserType == 5 ? 'table-style' : 'right-table'">
        <div class="top-filter">
          <el-input v-model="name" placeholder="请输入名字" size="small" class="name-input"></el-input>
          <butn btntype="primary" @click="queryClick()" title="查询"></butn>
          <butn class="czButn" @click="resetClick()" title="重置"></butn>
        </div>
        <div :key="'table' + filters.classUserType">
          <el-table ref="pageListTable" border :data="tableData"
            :header-row-style="{ color: '#343C4A', fontWeight: 500 }"
            @selection-change="handleSelectionChange"
            :row-key="getRowKeys"
            :row-style="{ color: '#51627D', fontWeight: 400 }"
            :header-cell-style="{ background: '#DCE7FA', color: '#343C4A', fontWeight: 500 }">
            <el-table-column type="selection" width="40" :selectable="selectInit" :reserve-selection="true">
            </el-table-column>
            <el-table-column prop="userName" label="姓名" show-overflow-tooltip width="100">
            </el-table-column>
            <el-table-column prop="deptName" label="单位" show-overflow-tooltip width="200">
            </el-table-column>
            <el-table-column prop="unitPosition" label="单位及职务" show-overflow-tooltip></el-table-column>
          </el-table>
        </div>
        <el-pagination class="pagination" @size-change="sizeChange" @current-change="pageChange"
          :current-page="currentPage" :page-size="size" :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper" :total="total" background hide-on-single-page />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click.native="submit()" title="确定"></butn>
      <butn class="czButn" @click.native="cancel()" title="取消"></butn>
    </div>
  </el-dialog>
</template>

<script>
import LeftLazyTree from "@/components/tree/leftLazyTree.vue";
import { pageByDeptOrPermission, saveBatchWorkers } from "@/api/classOffline.js";
import { getEnums, clearObject } from "@/utils/common.js";
import butn from "@/components/button/index";

export default {
  name: "selectStudents",
  components: {
    LeftLazyTree,
    butn,
  },
  props: {
    addWorkerDialog: {
      type: Object,
      default: () => {
        return {
          show: false,
        };
      },
    },
    classId: {
      type: String,
      default: () => "",
    },
    title: {
      type: String,
      default: () => "新增工作人员",
    },
  },
  data() {
    return {
      getRowKeys(row) {
        return row.uuid;
      },
      userAddTypeList: [],
      filters: {
        classUserType: "",
      },
      tableData: [],
      name: "",
      deptLevelCodes: null,
      total: 0,
      currentPage: 1,
      size: 10,
      selectWorkers: []
    };
  },
  created() {
    getEnums(
      ["CLASS_USER_ADD_TYPE"],
      this,
      ["userAddTypeList"],
      [false]
    );
  },
  methods: {
    changeType(val) {
      if (!!val) {
        this.currentPage = 1;
        this.total = 0;
        this.tableData = [];
        this.selectWorkers = [];
        if (this.deptLevelCodes && this.deptLevelCodes.length > 0 || val == 5) {
          this.getList();
        }
      }
    },
    selectInit(row) {
      return !row.isCheck;
    },
    resetClick() {
      this.name = "";
      this.queryClick();
    },
    queryClick() {
      if (this.deptLevelCodes || this.filters.classUserType == 5) {
        this.currentPage = 1;
        this.getList();
      } else {
        this.$message.warning("请先选择部门或学院！");
      }
    },
    submit() {
      if (this.selectWorkers.length > 0) {
        let userList = [];
        for (let i=0; i<this.selectWorkers.length; i++) {
          userList.push({
            userId: this.selectWorkers[i].uuid,
            userMobile: this.selectWorkers[i].userMobile,
            userName: this.selectWorkers[i].userName,
            unitPosition: this.selectWorkers[i].unitPosition,
          });
        }
        saveBatchWorkers({
          classId: this.classId,
          classUserType: this.filters.classUserType,
          users: userList,
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.$emit("closeSelect", true);
        });
      } else {
        this.$message.error("请选择工作人员！");
      }
    },

    cancel() {
      this.$emit("closeSelect");
    },
    handleSelectionChange(val) {
      let selectWorkers = val.filter(
        (ele) => ele.isCheck == 0
      );
      this.selectWorkers = selectWorkers;
    },
    select(obj) {
      this.currentPage = 1;
      this.deptLevelCodes = obj.deptLevelCodes;
      this.getList();
    },
    clearCheckedNodes() {
      this.deptLevelCodes = null;
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    // 列表数据
    getList() {
      let params = clearObject({
        ...this.filters,
        deptLevelCodes: this.deptLevelCodes,
        page: this.currentPage,
        limit: this.size,
        name: this.name,
        classId: this.classId,
      });
      pageByDeptOrPermission(params).then(({ code, data }) => {
        if (code !== 0) return;
        let { records, total } = data;
        this.tableData = records;
        this.total = total;
        let rows = [];
        this.tableData.forEach((x, i) => {
          if (x.isCheck == 1) {
            rows.push(this.tableData[i]);
          }
        });
        setTimeout(() => {
          rows.forEach((row) => {
            this.$refs.pageListTable.toggleRowSelection(row, true);
          });
        }, 200);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.role_rect {
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 16px;
  /deep/ .form_content .el-form-item {
    margin-bottom: 12px;
  }
}
/deep/ .el-table {
  max-height: 390px;
  overflow: auto;
}

/deep/ .el-dialog__body {
  padding: 20px;
  height: 1200px;
}

/deep/ .el-select__tags {
  height: 32px;
  overflow: hidden;
}

.main-contant {
  display: flex;
  min-height: 500px;
}

.left-tree {
  width: 235px;
  margin-right: 10px;
  max-height: 450px;
}

.right-table {
  width: calc(100% - 235px);
}
.table-style {
  width: 100%;
}

.top-filter {
  margin-bottom: 10px;
  text-align: right;
}

.filter-item {
  width: 180px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.filter-item-statu {
  width: 100px;
  margin-right: 10px;
}

.pagination {
  float: right;
}

.name-input {
  width: 180px;
  margin-right: 10px;
}
</style>
